module.exports = __webpack_public_path__ + "static/media/5.11e2136f.jpg";